import React, { useState } from 'react';
import {
  Environment,
  getCurrentEnvironment,
  setCurrentEnvironment,
  getEnvironmentOptions,
} from '../utils/environment';

const SESSION_STORAGE_KEY = 'gather.admin.session';

interface EnvSwitcherProps {
  variant?: 'header' | 'inline';
}

export const EnvSwitcher = ({
  variant = 'header',
}: EnvSwitcherProps): React.JSX.Element => {
  const [env, setEnv] = useState<Environment>(getCurrentEnvironment());
  const options = getEnvironmentOptions();

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>): void => {
    const next = e.target.value as Environment;
    if (next === env) return;

    const confirmed = window.confirm(
      `Switch API to ${next}?\n\nYou will be signed out and the page will reload.`,
    );
    if (!confirmed) {
      e.target.value = env;
      return;
    }

    try {
      localStorage.removeItem(SESSION_STORAGE_KEY);
    } catch {
      // ignore
    }
    setCurrentEnvironment(next);
    setEnv(next);
    window.location.replace('/admin');
  };

  return (
    <div
      className={`env-switcher env-switcher--${variant} env-switcher--${env}`}
    >
      <span className="env-switcher__label">API</span>
      <select
        className="env-switcher__select"
        value={env}
        onChange={handleChange}
        aria-label="Switch API environment"
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
};
